<template>
    <div class="carouselSlide">
        <div class="carouselSlide__line">
            <div class="carouselSlide__line__block simple">
                <div class="carouselSlide__line__block__title">
                    {{ slide[0].title }}
                </div>

                <router-link :to="{ path: slide[0].link, hash: `/slide1` }"
                    class="carouselSlide__line__block__link secondary-button">
                    Подробнее
                </router-link>

                <div class="carouselSlide__line__block__emoji">
                    {{ slide[0].src }}
                </div>
            </div>

            <div :style="{
                'background-image': 'url(' + require(`@/assets/img/mainPage/${slide[1].src}`) + ')',
                'background-color': '#12121299',
            }" class="carouselSlide__line__block imageBlock">
                <div class="carouselSlide__line__block__title">
                    {{ slide[1].title }}
                </div>

                <router-link :to="{ path: slide[1].link, hash: `/slide3` }"
                    class="carouselSlide__line__block__link secondary-button">
                    Подробнее
                </router-link>
            </div>
        </div>

        <div class="carouselSlide__line">
            <div :style="{
                'background-image': 'url(' + require(`@/assets/img/mainPage/${slide[2].src}`) + ')',
                'background-color': '#12121299',
            }" class="carouselSlide__line__block imageBlock">
                <div class="carouselSlide__line__block__title">
                    {{ slide[2].title }}
                </div>

                <router-link :to="{ path: slide[2].link, hash: `/slide4` }"
                    class="carouselSlide__line__block__link secondary-button">
                    Подробнее
                </router-link>
            </div>

            <div class="carouselSlide__line__block simple">
                <div class="carouselSlide__line__block__title">
                    {{ slide[3].title }}
                </div>

                <router-link :to="{ path: slide[3].link, hash: `/slide2` }"
                    class="carouselSlide__line__block__link secondary-button">
                    Подробнее
                </router-link>

                <div class="carouselSlide__line__block__emoji">
                    {{ slide[3].src }}
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss" src="./style.scss"></style>

<script src="./script.js"></script>
